export var ActionEnum;
(function (ActionEnum) {
    ActionEnum["EXPOSE"] = "expose";
    ActionEnum["EXPOSE_INTERACTION"] = "exposeInteraction";
    ActionEnum["LEAD_INTERACTION"] = "leadInteraction";
    ActionEnum["EXPOSE_CONTACT"] = "contactRequest";
    ActionEnum["RECOMMENDATION_CLICK"] = "recommendationclick";
    ActionEnum["RECOMMENDATION_LIST"] = "recommendationlist";
    ActionEnum["LIST"] = "list";
    ActionEnum["LIST_PAGING"] = "listpaging";
    ActionEnum["MAP_INTERACTION"] = "mapInteraction";
})(ActionEnum || (ActionEnum = {}));
export var InteractionEnum;
(function (InteractionEnum) {
    InteractionEnum["CLICK"] = "clickLead";
    InteractionEnum["SCROLLING"] = "scrolling";
    InteractionEnum["IMAGE_SLIDE"] = "imageSlide";
    InteractionEnum["SCROLL_TO_PROPERTY_PROVIDER"] = "scrollToOffererFromImageCard";
    InteractionEnum["OPEN_MAP"] = "openMap";
    InteractionEnum["OPEN_MORE"] = "openMore";
})(InteractionEnum || (InteractionEnum = {}));
export var InteractionValueEnum;
(function (InteractionValueEnum) {
    InteractionValueEnum["FINANCING"] = "financing";
    InteractionValueEnum["SCHUFA"] = "schufa";
    InteractionValueEnum["VALUATION"] = "valuation";
})(InteractionValueEnum || (InteractionValueEnum = {}));
